// extracted by mini-css-extract-plugin
module.exports = {"row":"form-table-row_row__2u-4S","checkbox":"form-table-row_checkbox__C5J48","ellipsis":"form-table-row_ellipsis__g2h1L"};